/**
 * can be used only on components that are declared in the routes
 */
const WarnBeforeLeave = {
    beforeRouteLeave( to, from, next ) {
        if ( to.name === 'logout' || !this.warnBeforeLeaving ) {
            this.unbindWarnBeforeYouLeaveMixin();
            next( );
            return;
        }
        if (to.fullPath === from.fullPath) {
            next();
            return;
        }

        this.$modal.show(
            () => import( '@tenant/app/components/modals/ConfirmationModal.vue' ),
            {
                title: this.warnBeforeLeaveTitle,
                content: this.warnBeforeLeaveContent,
                confirmButton: this.warnBeforeLeaveConfirmButton,
                cancelButton: this.warnBeforeLeaveCancelButton,
                onConfirmFn: () => this.warnBeforeLeaveSwapConfirmCancel ? next(false) : next(),
                onCancelFn: () => this.warnBeforeLeaveSwapConfirmCancel ? next() : next(false)
            },
            {
                'max-width': 858,
                persistent: true,
            }
        );
    },
    data() {
        return {
            warnBeforeLeaving: false,
            warnBeforeLeaveSwapConfirmCancel: false,
            warnBeforeLeaveTitle: this.$t( '_common:messages.leaveRouteConfirm.title' ),
            warnBeforeLeaveContent: this.$t( '_common:messages.leaveRouteConfirm.content' ),
            warnBeforeLeaveConfirmButton: this.$t( '_common:buttons.leave' ),
            warnBeforeLeaveCancelButton: this.$t( '_common:buttons.cancel' ),
        };
    },
    methods: {
        bindWarnBeforeYouLeaveMixin() {
            setTimeout( () => {
                const watchProps = this.$options.warnBeforeLeaveMixinOptions.watchData;
                for ( const prop of watchProps ) {
                    const disposer = this.$watch( prop, () => {
                        this.warnBeforeLeaving = true;
                    }, { deep: true } );

                    this.watcherDisposers.push( disposer );
                }
            }, 1000 );
        },
        unbindWarnBeforeYouLeaveMixin() {
            this.cleanWarnBeforeYouLeaveMixin( );
        },
        forceWarnBeforeLeaveMixin() {
            this.warnBeforeLeaving = true;
        },
        cleanWarnBeforeYouLeaveMixin() {
            for ( const disposer of this.watcherDisposers ) {
                disposer();
            }
            this.warnBeforeLeaving = false;
            window.onbeforeunload = null;
        },
    },
    created() {
        this.watcherDisposers = [];
        this.$watch( 'warnBeforeLeaving', ( newValue ) => {
            if ( newValue ) {
                window.onbeforeunload = () => true;
            }
            else {
                window.onbeforeunload = null;
            }
        } );
    },
    destroyed() {
        this.cleanWarnBeforeYouLeaveMixin( );
    }
};

export default WarnBeforeLeave;
